
//XXX Q: should this code be shared with the theme deep merge? (in merge.ts)

/* Doesn't merge arrays */
export function deepPatch(base:any,patch:any)
{
	for (const key of Object.keys(patch)) 
		if (patch[key] == null)
			delete base[key];
		else if (base[key] == null)
			base[key] = patch[key];
		else if (typeof patch[key]=='object' && typeof base[key]=='object' && !Array.isArray(patch[key]) && !Array.isArray(base[key]))
			deepPatch(base[key],patch[key]);
		else 
			base[key] = patch[key];
}

